import { render, staticRenderFns } from "./CreditCard.vue?vue&type=template&id=2dd482a2&scoped=true"
import script from "./CreditCard.vue?vue&type=script&lang=js"
export * from "./CreditCard.vue?vue&type=script&lang=js"
import style0 from "./CreditCard.vue?vue&type=style&index=0&id=2dd482a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd482a2",
  null
  
)

export default component.exports